function renderCoreStorageProviderContentTemplate({
  activeProviderExportName
}: {
  activeProviderExportName: string
}): string {
  return `  if (${activeProviderExportName}.isConfigured()) {
    return ${activeProviderExportName}
  }

`
}

function renderCoreStorageProviderGeneratedFunctionTemplate({
  providerImport,
  providerBranch
}: {
  providerImport: string
  providerBranch: string
}): string {
  return `import { localStorageProvider } from '@admin/actions/storage/local'
${providerImport}import type { AdminStorageProvider } from '@admin/actions/storage/types'

export function getStorageProvider(): AdminStorageProvider {
${providerBranch}  return localStorageProvider
}
`
}

export function renderCoreStorageProviderRenderer(
  request:
    | {
        kind: 'renderCoreStorageProviderContentTemplate'
        props: {
          activeProviderExportName: string
        }
      }
    | {
        kind: 'renderCoreStorageProviderGeneratedFunctionTemplate'
        props: {
          providerImport: string
          providerBranch: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderCoreStorageProviderContentTemplate':
      return renderCoreStorageProviderContentTemplate(request.props)
    case 'renderCoreStorageProviderGeneratedFunctionTemplate':
      return renderCoreStorageProviderGeneratedFunctionTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
